import React, { useEffect, useMemo, useState } from "react";
import {
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  TableFooter,
  TableSortLabel,
  Menu,
  Paper,
  Alert,
  AlertTitle,
} from "@mui/material";

import { makeStyles } from "@material-ui/core";

import { SlOptionsVertical } from "react-icons/sl";
import { Box, Checkbox, MenuItem } from "@mui/material";

import { RiDeleteBin6Line } from "react-icons/ri";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import { useDispatch } from "react-redux";
import { MdNotInterested } from "react-icons/md";
import { BiSortAlt2 } from "react-icons/bi";

import "../LandingPage.css";

import usePrivilegeCheck from "../../../constants/customHooks/UsePrivilegeCheck";

export const FaqTable = ({ columns, data, component, isPresentMap }) => {
  // custom Hooks
  const { privilege, hasPrivilege } = usePrivilegeCheck();

  const [actionButtonShow, setActionButtonShow] = useState(null);
  const [tableId, setTableId] = useState("");

  const openActionButton = Boolean(actionButtonShow);

  const handleClickAction = (event, id) => {
    console.log(id, "evide id kitttuvo");
    setActionButtonShow(event.currentTarget);
    setTableId(id);
  };

  const handleCloseAction = () => {
    setActionButtonShow(null);
  };

  const CustomSortIcon = ({ direction }) => {
    return direction === "asc" ? (
      <img
        src="/menuIcons/tableUpSort.png"
        className="administratCustomIcon"
        alt="gsl"
        style={{ padding: "15px" }}
      />
    ) : (
      <BiSortAlt2 className="administratCustomIcon" />
    );
  };

  // sorting table
  const [sortBy, setSortBy] = useState(""); // Current sort column
  const [sortOrder, setSortOrder] = useState("asc"); // Current sort order

  const requestSort = (column) => {
    let newSortOrder = "asc";

    if (column === sortBy && sortOrder === "asc") {
      newSortOrder = "desc";
    }

    setSortBy(column);
    setSortOrder(newSortOrder);
  };
  let sortedData = useMemo(() => {
    if (sortBy && data) {
      const sortedItems = [...data].sort((a, b) => {
        if (sortOrder === "asc") {
          return a[sortBy] < b[sortBy] ? -1 : 1;
        } else {
          return a[sortBy] < b[sortBy] ? 1 : -1;
        }
      });
      return sortedItems;
    }
    return data;
  }, [data, sortBy, sortOrder]);

  //   const handleClose = () => setOpen(false);

  // Create a function to handle selecting individual rows:

  if (!hasPrivilege("isadministrationView") && privilege !== null) {
    return (
      <Alert severity="error">
        <AlertTitle>warning</AlertTitle>
        You don't have permission to access — <strong>this page.!</strong>
      </Alert>
    );
  }

  // Handle_Delete

  const handleDelete = (tableId) => {
    isPresentMap((prevData) => {
      const newData = prevData.filter((item) => item.slNo !== tableId);
      const updatedData = newData.map((item, index) => ({
        ...item,
        slNo: index + 1,
      }));

      return updatedData;
    });
  };

  console.log(sortedData, "haivishnu");
  return (
    <>
      <Table className="landingTable">
        <TableHead>
          <TableRow className="landingTableCell">
            <TableCell>
              <Checkbox
                // checked={selectedRows.length === sortedData.length}
                // onChange={handleSelectAllRows}
                style={{ color: "#f81b82" }}
              />
            </TableCell>
            {columns?.map((column) => {
              if (column.hidden) {
                return null;
              }
              return (
                <TableCell key={column.field} className="landingTableCell">
                  <TableSortLabel
                    className="landingHeaderText"
                    active={column === sortBy}
                    direction={sortOrder}
                    onClick={() => requestSort(column)}
                    IconComponent={column.field !== "action" && CustomSortIcon}
                  >
                    {column.title}
                  </TableSortLabel>
                </TableCell>
              );
            })}
            <TableCell></TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {sortedData?.map((item, indx) => (
            <TableRow className="landingTable" key={indx}>
              <TableCell>
                <Checkbox
                  // checked={selectedRows.includes(item.id)}
                  // onChange={() => handleSelectRow(item.id)}
                  style={{ color: "#f81b82" }}
                />
              </TableCell>
              <TableCell>{item.slNo}</TableCell>
              <TableCell>{item.value}</TableCell>
              <TableCell>{item.answer}</TableCell>


              <TableCell>
                <SlOptionsVertical
                  id="demo-positioned-button"
                  aria-controls={
                    openActionButton ? "demo-positioned-menu" : undefined
                  }
                  aria-haspopup="true"
                  aria-expanded={openActionButton ? "true" : undefined}
                  onClick={(e) => {
                    console.log("evidenkilum vannno");
                    handleClickAction(e, item.slNo);
                  }}
                  variant="outlined"
                  style={{ marginLeft: "10px", color: "#F80B7A" }}
                />
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
        <TableFooter />
      </Table>

      {/* TABLE ACTION MENU START*/}
      <Menu
        id="demo-positioned-menu"
        aria-labelledby="demo-positioned-button"
        anchorEl={actionButtonShow}
        open={openActionButton}
        onClose={handleCloseAction}
        MenuListProps={{
          "aria-labelledby": "basic-button",
        }}
        anchorOrigin={{
          vertical: "bottom", // Change from "top" to "bottom"
          horizontal: "left",
        }}
        transformOrigin={{
          vertical: "top", // Change from "top" to "bottom"
          horizontal: "left",
        }}
        sx={{
          borderColor: "black",
          borderRadius: "24px",
          mt: 1.5,
          width: "auto",
          height: "auto",
        }}
      >
        <Box style={{ display: "flex", justifyContent: "flex-end" }}>
          {privilege?.isadministrationDelete !== false ? (
            <MenuItem>
              {/* {component !=="holiday" ? (
                <RiDeleteBin6Line
                  onClick={() => RoledeleteHandler(tableId)}
                  className="icons"
                  style={{
                    fontSize: "lg",
                    width: "20px",
                    height: "19px",
                  }}
                />
              ) : ( */}
              <RiDeleteBin6Line
                onClick={() => {
                  Swal.fire({
                    title: "Are you sure?",
                    text: "You won't be able to revert this!",
                    icon: "warning",
                    showCancelButton: true,
                    confirmButtonColor: "#3085d6",
                    cancelButtonColor: "#d33",
                    confirmButtonText: "Yes, delete it!",
                  }).then((result) => {
                    if (result.isConfirmed) {
                      console.log("aravide");
                      handleDelete(tableId);
                      setActionButtonShow(false);
                      Swal.fire(
                        "Deleted!",
                        "Your file has been deleted.",
                        "success"
                      );
                    }
                  });
                }}
                style={{
                  fontSize: "lg",
                  width: "20px",
                  height: "19px",
                }}
                className="icons"
              />
            </MenuItem>
          ) : (
            <MdNotInterested
              className="icons"
              onClick={() => {
                Swal.fire({
                  icon: "error",
                  title: "Oops...",
                  text: "you don't have delete permission",
                });
              }}
            />
          )}
        </Box>
      </Menu>
    </>
  );
};
